/* global Reveal */

import React, { Component } from 'react';
// import makeVideoPlayableInline from 'iphone-inline-video';

import './App.css';
import logo from '../media/carsin-logo.png';

// Reveal.js
import './reveal/css/reveal.css';
import './reveal/css/theme/beige.css';
import './reveal/lib/js/head.min.js';
import './reveal/js/reveal.js';

import Menu from './Menu';
import Slide from './Slide';

import content from './content.json';

/*
const makeVideoAutoplayableIOS = event => {
  const videos = document.getElementsByTagName('video');
  for (let i = 0; i < videos.length; i++) {
    const video = videos[i];
    if (!video.hasAttribute('autoplay')) {
      console.log('setting video!');
      video.setAttribute('autoplay', 'true');
      video.setAttribute('muted', 'true');
      video.setAttribute('webkit-playsinline', 'true');
      makeVideoPlayableInline(video, false);
    }
  }
}
*/

const isMobileBrowser = () => {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

// const isiOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

const SECTIONS = [
  { fin: 'Alkuun', eng: 'Home', start: 0 },
  { fin: 'Ihmiset', eng: 'People', start: 1 },
  { fin: 'Tila', eng: 'The property', start: 11 },
  { fin: 'Tarhojen kasvukausi', eng: 'Growing season', start: 14 },
  { fin: 'Kellari', eng: 'The cellar', start: 29 },
  { fin: 'Sadonkorjuun valmistelut', eng: 'Harvest preparations', start: 35 },
  { fin: 'Sadonkorjuu', eng: 'Harvest', start: 47 },
  { fin: 'Viininvalmistus', eng: 'Winemaking', start: 83 },
  { fin: 'Carsinin tunnelmaa', eng: 'Carsin vibes', start: 98 },
  { fin: 'Kiitokset', eng: 'Thanks', start: 111 },
];

class App extends Component {
  constructor(props) {
    super(props);

    this.switchLanguage = this.switchLanguage.bind(this);
    this.toggleAutoplay = this.toggleAutoplay.bind(this);

    const useEnglish =
      window.location.hash && window.location.hash.indexOf('en') !== -1;

    this.state = {
      language: useEnglish ? 'eng' : 'fin',
      autoplaying: false,
    };
  }

  componentDidMount() {
    Reveal.initialize({
      center: false,
      controls: false,
      history: true,
      overview: true,
      hideAddressBar: true,
      transition: 'none',
      transitionSpeed: 'fast',
      backgroundTransition: 'slide',
      margin: 0,
      width: '100%',
      height: '100%',
      viewDistance: 3,
      keyboard: {
        // 'a'
        65: () => {
          this.toggleAutoplay();
        },
      },
    });

    if (process.env.NODE_ENV === 'production' && window.ga) {
      const currentSlideIndex = Reveal.getIndices().h;
      const pageName =
        currentSlideIndex === 0 ? '/' : `/#/${currentSlideIndex}`;
      window.ga('create', 'UA-85786603-1', 'auto');
      window.ga('set', 'page', pageName);
      window.ga('send', 'pageview');

      Reveal.addEventListener('slidechanged', (event) => {
        const pageName = event.indexh === 0 ? '/' : `/#/${event.indexh}`;
        window.ga('set', 'page', pageName);
        window.ga('send', 'pageview');
        // makeVideoAutoplayableIOS();
      });
    }
    // makeVideoAutoplayableIOS();
  }

  toggleAutoplay() {
    if (this.state.autoplaying) {
      console.log('Disabling autoplay');
      Reveal.configure({ autoSlide: 0, loop: false });
      this.setState({ autoplaying: false });
    } else {
      console.log('Enabling autoplay');
      Reveal.configure({ autoSlide: 7000, loop: true });
      this.setState({ autoplaying: true });
    }
  }

  switchLanguage(e) {
    e.preventDefault();

    if (this.state.language === 'fin') {
      this.setState({ language: 'eng' });
      if (history.pushState) {
        history.pushState(null, null, '#en');
      }
    } else {
      this.setState({ language: 'fin' });
      if (history.pushState) {
        history.pushState(null, null, '#');
      }
    }
  }

  render() {
    const sections = SECTIONS.map((s) => ({
      name: s[this.state.language],
      start: s.start,
    }));

    const autoplayVideos = !isMobileBrowser(); // || isiOS();

    return (
      <div className="slides">
        <section
          data-background-image={require('../media/photos/title-slide-background.jpg')}
          data-background-position="bottom"
          className="title-slide"
        >
          <Menu currentSlide={0} sections={sections} dark hideLabel />
          <a
            onClick={this.switchLanguage}
            className="top-right"
            href={this.state.language === 'fin' ? '/#en' : '/'}
          >
            {this.state.language === 'fin' ? 'In English' : 'Suomeksi'}
          </a>
          <img src={logo} className="logo" alt="Chateau Carsin logo" />
          <div className="presentation-title">
            {this.state.language === 'fin'
              ? 'Suomalaista viiniä Ranskasta'
              : 'Finnish wine from France'}
          </div>
          <button
            className="start-button"
            style={{
              minWidth:
                this.state.language === 'fin'
                  ? '274px'
                  : '322px' /* No idea why the line wraps and this is needed */,
            }}
            onClick={() => {
              Reveal.next();
            }}
          >
            {this.state.language === 'fin'
              ? 'Aloita tarina'
              : 'Start the journey'}
          </button>
        </section>
        {content.slides.map((slide, i) => {
          return (
            <Slide
              slide={slide}
              key={i}
              slideNumber={i + 1}
              language={this.state.language}
              autoplayVideos={autoplayVideos}
              sections={sections}
              isFirstSlide={i === 0}
              isLastSlide={i === content.slides.length - 1}
            />
          );
        })}
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/